import React from 'react';
export default function InputField({
  label,
  type = 'text',
  name,
  value,
  onChange,
  placeholder,
  className = '',
  ...rest
}) {
  return (
    <div>
      <label className="block text-[14px] font-medium text-[#1B1C33]">
        {label}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`mt-2.5 w-full rounded-[7px] border border-[#C1BECE] px-4 py-2 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#FEA12B]/60 ${className}`}
        {...rest}
      />
    </div>
  );
}

